var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"22","viewBox":"0 0 20 22","fill":"none"}},[_c('path',{attrs:{"d":"M4.5332 10.7998V16.4998L9.5332 18.9998L14.5332 16.4998V10.7998","stroke":"#333333"}}),_c('path',{attrs:{"d":"M17.5332 9L9.5332 13.5L1.5332 9L9.5332 4L17.5332 9ZM17.5332 9V13.5","stroke":"#333333"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }